import React from 'react';
import {Images, ConsultationGroup} from '@/constants';
import {Text} from '@/ui-kits';
import {useNavigate} from 'react-router-dom';
import {Routes} from '@/navigation/Routes';

interface NoConsultationProps {
  tab: ConsultationGroup;
}

interface Message {
  title: string;
  description: string;
  showImage?: boolean;
  showLearnMore?: boolean;
}

export const NoSpecialistConsultation: React.FC<NoConsultationProps> = ({tab}) => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate(Routes.DASHBOARD);
  };

  const messages: Record<ConsultationGroup, Message> = {
    [ConsultationGroup.Ongoing]: {
      title: 'No Ongoing Consultations',
      description: "You don't have any consultations right now. Once patients request your expertise, cases will appear here.",
      showImage: true,
      showLearnMore: true,
    },
    [ConsultationGroup.Past]: {
      title: 'No Completed Consultations Yet',
      description: 'Once you finish reviewing and submit your second opinions, completed cases will appear here for quick access.',
      showImage: false,
      showLearnMore: false,
    },
    [ConsultationGroup.ConsultationHistory]: {
      title: 'No Consultation History Found',
      description: 'Your old and cancelled consultations will appear here once available.',
      showImage: false,
      showLearnMore: false,
    },
  };

  const currentMessage = messages[tab];

  return (
    <div
      style={{
        borderRadius: '25px',
        opacity: 1,
      }}
      className="bg-white shadow-lg border border-ui_grey p-6 sm:p-8 md:p-12 flex flex-col items-center justify-center w-[90%] sm:w-full max-w-sm sm:max-w-full lg:max-w-[1192px] h-auto md:h-[611px] mx-auto mt-12 sm:mt-0">
      {/* Illustration - Only show for Ongoing tab */}
      {currentMessage.showImage && (
        <div className="mb-6 sm:mb-8">
          <img src={Images.no_ongoing_consultation} alt="No ongoing consultations" className="w-72 sm:w-96 h-auto" />
        </div>
      )}

      {/* Heading */}
      <Text variant="heading" className="text-ui_blue mb-3 sm:mb-4 text-center px-4 sm:px-0 !text-xl sm:!text-3xl">
        {currentMessage.title}
      </Text>

      {/* Description */}
      <Text
        variant="body"
        className="text-ui_input_border_dark text-center mb-6 sm:mb-8 max-w-xs sm:max-w-md md:max-w-2xl lg:max-w-4xl px-4 sm:px-0 break-words">
        {currentMessage.description}
      </Text>

      {/* Learn How it Works Link - Only show for Ongoing tab */}
      {currentMessage.showLearnMore && (
        <button
          onClick={handleLearnMore}
          className="text-ui_blue font-FigtreeSemiBold text-base sm:text-lg underline hover:text-ui_blue_light transition-colors">
          Learn How it Works
        </button>
      )}
    </div>
  );
};
